function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "rgb(0,0,0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m60.1693 14.3674c.3683-3.3123 3.8129-5.34403 6.8899-4.0639l13.0597 5.4333c.9579.3984 2.0159.4891 3.0276.2594l13.7956-3.1321c3.3409-.7585 6.4379 1.9911 6.0799 5.3981l-1.439 13.7018c-.111 1.0605.119 2.1289.658 3.049l6.961 11.8865c1.703 2.9067.102 6.6308-3.178 7.3961l-13.9982 3.2656c-.9936.2317-1.8925.7619-2.576 1.5194l-9.6301 10.6709c-2.2568 2.5007-6.2904 2.0997-8.0107-.7963l-7.035-11.843c-.5446-.9168-1.3681-1.6355-2.3501-2.0511l-12.6878-5.3695c-3.1548-1.3352-4.063-5.3757-1.783-7.9324l9.4155-10.5584c.6904-.7743 1.123-1.7442 1.2376-2.7752z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38 29c0-2.2092-1.7909-4-4-4s-4 1.7908-4 4v1h-1c-2.2091 0-4 1.7908-4 4 0 2.2091 1.7909 4 4 4h1v1c0 2.2091 1.7909 4 4 4s4-1.7909 4-4v-1h1c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m83 86c0-2.2092-1.7909-4-4-4s-4 1.7908-4 4v1h-1c-2.2091 0-4 1.7908-4 4 0 2.2091 1.7909 4 4 4h1v1c0 2.2091 1.7909 4 4 4s4-1.7909 4-4v-1h1c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m99 78c2.761 0 5-2.2386 5-5s-2.239-5-5-5c-2.7614 0-5 2.2386-5 5s2.2386 5 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 57c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.6916 55.2858-41.0254 41.0253c-1.95261 1.9527-1.9526 5.1189 0 7.0709l5.0659 5.066c1.9526 1.953 5.1185 1.953 7.0711 0l41.9147-41.9146-4.383-7.3784c-.1089-.1834-.2736-.3271-.47-.4102z"
}));

var SvgMagicWand = function SvgMagicWand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 512,
    viewBox: "0 0 120 120",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagicWand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magic-wand.e2aebb3a.svg";
export { ForwardRef as ReactComponent };